import { isHostAppFeatureEnabled } from 'owa-hostapp-feature-flags';
import { isFeatureEnabled } from 'owa-feature-flags';

export function isSupportEnabled(): boolean {
    return isHostAppFeatureEnabled('diagInAppSupport') && isFeatureEnabled('mon-diag-inappsupport');
}

export function isDiagFeedbackEnabled(): boolean {
    return isHostAppFeatureEnabled('diagFeedbackJs') && isFeatureEnabled('mon-diag-feedbackjs');
}
